import { SelectOption } from "./select-option.model";

export function toSelectOption<T extends Record<string, any>>(
    data: T,
    valueField: string,
    labelField: string,
    type?: string
  ): SelectOption {
    return {
      label: data[labelField] as string,
      value: data[valueField] as string,
      category: type,
    }
  }